module.exports = __webpack_public_path__ + "static/media/grey_polygon.1bda3e02.svg";